import { create } from 'zustand';
import { fetchRealtimeView } from '../utils/fetchRealtime';

const useRealtimeStore = create((set) => ({
  realtimeAppointments: [],
  isFetchingRealtime: false,
  isFetchingRealtimeError: false,
  isFetchingRealtimeSuccess: false,
  fetchRealtimeAppointments: async () => {
    set({
      isFetchingRealtime: true,
      isFetchingRealtimeError: false,
      isFetchingRealtimeSuccess: false,
    });
    try {
      const res = await fetchRealtimeView();
      set({
        realtimeAppointments: res || [],
        isFetchingRealtimeSuccess: true,
      });
    } catch (err) {
      console.error('Error fetching MR realtime data', err);
      set({
        realtimeAppointments: [],
        isFetchingRealtimeError: true,
        isFetchingRealtimeSuccess: false,
      });
    } finally {
      set({ isFetchingRealtime: false });
    }
  },
}));

export default useRealtimeStore;
